import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Grid } from '@material-ui/core';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { DateRange } from '@mui/lab/DateRangePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MobileDateRangePicker from '@mui/lab/MobileDateRangePicker';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import axios from "axios";
import jaLocale from 'date-fns/locale/ja';
import moment from 'moment';
import React, { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';
import { API_URL, LICENSE_LIST } from "../../Const";
import ConfirmDialog from "../Dialog";
import GenericTemplate from "../templates/GenericTemplate";
import { useSetRecoilState } from 'recoil';
import { createdCorporateIdState } from '../../globalStates/createdCorporateId';
import { useLoadingOverlay } from '../../utilHooks/loadingOverlay';


// フォームの型
interface ConstructionCreateFormInput {
  company_id: string,
  company_name: string,
  company_name_kana: string,
  total_user_count: string,
  total_capacity: string,
  remarks: string
}

// バリデーションルールs
const schema = yup.object({
  company_id: yup
    .string()
    .required('必須項目です'),
  company_name: yup
    .string()
    .required('必須項目です'),
  company_name_kana: yup
    .string(),
  total_user_count: yup
    .string()
    .matches(/^[0-9]*$/, '数値を入力してください'),
  total_capacity: yup
    // .number()
    .string()
    .matches(/^[0-9]*$/, '数値を入力してください'),
  remarks: yup
    .string()
})


const ConstructionCreate: React.FC = () => {
  const { openLoading, closeLoading } = useLoadingOverlay()

  /*送信パラメータ*/
  const [company_id, setCompanyId] = useState('');
  const [company_name, setCompanyName] = useState('');
  const [company_name_kana, setCompanyNameKana] = useState('');
  const [contract_type, setContractType] = useState('0');
  const [from_date, setFromDate] = useState('開始時期');
  const [to_date, setToDate] = useState('終了時期');
  const [total_user_count, setTotalUserCount] = useState('0');
  const [total_capacity, setTotalCapacity] = useState('0');
  const [is_active, setIsActive] = useState('1');
  const [remarks, setRemarks] = useState('');
  const [contract_id, setContractId] = useState('');
  /* 送信パラメータ値設定 */
  const changeCompanyId = (e: any) => {
    setCompanyId(e.target.value)
  }
  const changeCompanyName = (e: any) => {
    setCompanyName(e.target.value)
  }
  const changeCompanyNameKana = (e: any) => {
    setCompanyNameKana(e.target.value)
  }
  const changeContractType = (e: any) => {
    setContractType(e.target.value)
  }
  const changeFromDate = (e: any) => {
    setFromDate(e.target.value)
  }
  const changeToDate = (e: any) => {
    setToDate(e.target.value)
  }
  const changeTotalUserCount = (e: any) => {
    setTotalUserCount(e.target.value)
  }
  const changeTotalCapacity = (e: any) => {
    setTotalCapacity(e.target.value)
  }
  const changeIsActive = (e: any) => {
    setIsActive(e.target.value)
  }
  const changeRemarks = (e: any) => {
    setRemarks(e.target.value)
  }

  const [value, setValue] = React.useState<DateRange<Date>>([null, null]);
  const [userPosts, setUserPosts] = useState([{ user_id: "" }])
  const [constructionPosts, setConstructionPosts] = useState([{ construction_id: "" }])
  const [is_active_val, setIsActiveVal] = useState(is_active)
  const [contract_type_val, setContractTypeVal] = useState(contract_type)

  let jsonlist = JSON.parse(localStorage.getItem("datalist") || '{}')
  const history = useHistory();

  const setCreatedCorporateId = useSetRecoilState(createdCorporateIdState)

  //バリデーション設定
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ConstructionCreateFormInput>({
    resolver: yupResolver(schema),
  })

  // 適切な形式で容量を表示
  const capacity = ({ val }: { val: string }) => {
    const size = Number(val)
    const gb = 1024000000
    // 表示単位はGB固定とし、小数点第二位まで表示
    const capacity_val = Math.floor((size / gb) * 100) / 100
    return capacity_val // + ' ' + 'GB'
  }

  // 利用停止文字列
  const active_state = ({ val }: { val: string }) => {
    if (val == "1") {
      return false
    } else {
      return true
    }
  }

  // 工事データから利用容量を産出
  const sumFileSize = () => {
    let subtotal = 0
    constructionPosts.forEach(item => {
      let size = (item as any)?.storage_size
      if (!isNaN(size)) {
        subtotal += parseInt(size)
      }
    })
    return subtotal.toString()
  }

  // 追加ボタン押下時の処理
  const onSubmit: SubmitHandler<ConstructionCreateFormInput> = (data) => {
    handleClickOpenEdit()
  }

  /*スピナー処理*/
  const [loading, setLoading] = React.useState(false);
  /*スピナー処理*/

  /*ダイアログ処理(キャンセル)*/
  const [openCancel, setOpenCancel] = React.useState(false);
  const handleClickOpenCancel = () => {
    setOpenCancel(true);
  };
  const gotoDetail = () => {
    // 詳細に戻る
    // history.push({ pathname: "/UserDetail", state: {id: s_user_id,comid: s_company_id}});
    history.push({ pathname: "/CorporateDetail", state: { company_id: company_id, company_name: company_name, company_name_kana: company_name_kana, contract_type: contract_type, from_date: from_date, to_date: to_date, total_user_count: total_user_count, total_capacity: total_capacity, is_active: is_active, remarks: remarks } })
  };
  const setConfirmOpenCancel = (check: any) => {
    setOpenCancel(check)
  };
  /*ダイアログ処理(キャンセル)*/

  /*ダイアログ処理(登録)*/
  const [openEdit, setOpenEdit] = React.useState(false);
  const handleClickOpenEdit = () => {
    setOpenEdit(true);
  };
  const createCompany = () => {
    if (!loading) {
      setLoading(true);
    }

    // 登録処理
    const param = {
      "company_id": company_id,
      "company_name": company_name,
      "company_name_kana": company_name_kana,
      "contract_type": contract_type_val,
      "total_capacity": total_capacity,
      "total_user_count": total_user_count,
      "from_date": moment(value[0]).format('yyyy/MM/DD'),
      "to_date": moment(value[1]).format('yyyy/MM/DD'),
      "is_active": is_active_val,
      "remarks": remarks,
      "contract_id": contract_id
    }
    console.log('param:', param)

    openLoading()
    axios.post(API_URL.COMPANY_CREATE,
      param,
      { headers: { Authorization: jsonlist.token.IdToken } },
    )
      .then(res => {
        // ユーザー作成画面に遷移する
        setCreatedCorporateId(res.data.data.company_id)
        history.push({ pathname: "/UserCreate" });
      })
      .catch(error => {
        // console.log(error.response.data.errMessage)
        alert(error.response.data.errMessage)
        setLoading(false);
      })
      .finally(() => {
        closeLoading()
      })

  };
  const setConfirmOpenEdit = (check: any) => {
    setOpenEdit(check)
  };
  /*ダイアログ処理(追加)*/

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log('contract_type:', event.target.value)
    setContractTypeVal(event.target.value);
  };

  // チェックボックスクリック時のイベント
  const clickCheckbox = (event: any) => {
    // ここでis_activeを反転
    console.log('check:', event.target.checked)
    if (event.target.checked == true) {
      setIsActiveVal('0')
    } else {
      setIsActiveVal('1')
    }
  };


  // 一覧へ戻る
  const gotoList = () => {
    history.push({ pathname: "/Companylist" });
  };




















  return (

    <GenericTemplate title="契約企業 新規作成">
      <Stack spacing={3} margin={2}></Stack>

      <div>
        <ConfirmDialog
          title="入力されているデータで登録しますか？"
          open={openEdit}
          setOpen={setConfirmOpenEdit}
          onConfirm={handleSubmit(createCompany)}
          loading={loading}
        >
          追加後ユーザー作成画面に遷移します。
        </ConfirmDialog>
      </div>

      <div>
        <ConfirmDialog
          title="一覧に戻りますか？"
          open={openCancel}
          setOpen={setConfirmOpenCancel}
          onConfirm={gotoList}
          loading={loading}
        >
          変更したデータは破棄されます
        </ConfirmDialog>
      </div>


      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} >
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">企業ID</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              type="string"
              {...register('company_id')}
              error={'company_id' in errors}
              helperText={errors.company_id?.message}
              onChange={changeCompanyId}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0}>
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">企業名</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              type="string"
              {...register('company_name')}
              error={'company_name' in errors}
              helperText={errors.company_name?.message}
              onChange={changeCompanyName}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0}>
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">企業名カナ</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              type="string"
              {...register('company_name_kana')}
              error={'company_name_kana' in errors}
              helperText={errors.company_name_kana?.message}
              onChange={changeCompanyNameKana}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">契約形態</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            {/* <TextField
                value={LICENSE[contract_type]}
              /> */}
            <TextField
              required
              id="outlined-select-currency-native"
              select
              label="プラン選択"
              value={contract_type_val}
              onChange={handleChange}
              SelectProps={{
                native: true,
              }}
              className="InsText2"
              variant="outlined"
            >
              {LICENSE_LIST.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </TextField>
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">契約期間</Grid>
          <Grid item xs={10}>
            <LocalizationProvider dateAdapter={AdapterDateFns} locale={jaLocale}>
              <MobileDateRangePicker
                startText={"開始時期"}
                endText={"終了時期"}
                value={value}
                onChange={(newValue) => {
                  setValue(newValue);
                }}
                renderInput={(startProps, endProps) => (
                  <React.Fragment>
                    <TextField {...startProps} />
                    <Box sx={{ mx: 2 }}> 〜 </Box>
                    <TextField {...endProps} />
                  </React.Fragment>
                )}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
      </Stack>


      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={4} md={2} xs={12} className="detail-title">最大ユーザー数</Grid>
          <Grid item={true} sm={8} md={2} xs={12}>
            <TextField
              className="small-text"
              type="string"
              defaultValue={'0'}
              {...register('total_user_count')}
              error={'total_user_count' in errors}
              helperText={errors.total_user_count?.message}
              onChange={changeTotalUserCount}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={4} md={2} xs={12} className="detail-title">最大容量(GB)</Grid>
          <Grid item={true} sm={8} md={2} xs={12}>
            <TextField
              className="small-text"
              type="string"
              defaultValue={'0'}
              {...register('total_capacity')}
              error={'total_capacity' in errors}
              helperText={errors.total_capacity?.message}
              onChange={changeTotalCapacity}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">備考</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              className="large-text"
              multiline
              type="string"
              {...register('remarks')}
              error={'remarks' in errors}
              helperText={errors.remarks?.message}
              onChange={changeRemarks}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={3} margin={2}></Stack>

      {/* 下部ボタンエリア */}
      <Stack spacing={0} margin={0}>
        <Grid item={true} container spacing={0}>
          <Grid item={true} sm={3} md={2} xs={10}>
            <Button
              color="primary"
              variant="contained"
              size="large"
              // onClick={handleClickOpenAdd}
              onClick={handleSubmit(onSubmit)}
            >
              追加
            </Button>
          </Grid>
          <Grid item={true} sm={5} md={6} xs={10}>
            <Button
              className="btnlink"
              color="primary"
              variant="contained"
              size="large"
              // component={Link}
              onClick={handleClickOpenCancel}
            // to="/Userlist"
            >
              キャンセル
            </Button>
          </Grid>
        </Grid>
      </Stack>





    </GenericTemplate>
  );
};

export default ConstructionCreate;